import api from "@/plugins/api";
export async function searchSirene(query, perPage) {
    const params = { q: query.trim() };
    if (perPage !== undefined)
        params.per_page = perPage;
    const response = await api.get("/organisations/sirene-search", { params });
    return {
        items: response.data.data,
        totalCount: response.data.pagination?.totalItems ?? 0,
    };
}
